import React from "react";
import View from "common/View";
import Report from "./Report";
import SystemInformationStatusHelp from "./Help";

const SystemInformationStatus = () => (
  <View
    className="container-lg"
    title="System Information"
    Help={SystemInformationStatusHelp}
  >
    <Report />
  </View>
);

export default SystemInformationStatus;
